export const enGb = {
  dashboard: "Dashboard",
};
